import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BillingStateService } from './store/billing-state.service';
import { InvoiceStateService } from './invoice/store/invoice-state.service';
import { CreditCardStateService } from './credit-card/store/credit-card-state.service';
import { UsageStateService } from './usage/store/usage-state.service';
import { PackageStateService } from './upgrade-or-downgrade/store/package-state.service';
import { SubscriptionStateService } from './subscription/store/subscription-state.service';
import { AuthService } from '../../../providers/auth.service';
import { SharedClientService } from '../shared/services/shared-client.service';

import { SubscriptionComponent } from './subscription/subscription.component';
import { UsageComponent } from './usage/usage.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { UpgradeOrDowngradeComponent } from './upgrade-or-downgrade/upgrade-or-downgrade.component';
import { OneTimeCreditsComponent } from './one-time-credits/one-time-credits.component';
import { InvoiceComponent } from './invoice/invoice.component';

import { IApp } from '../../../app';
import { Subject, Subscription } from 'rxjs';
import { BillingState } from './store/billing-state';


export class BillingComponent implements IApp , OnInit, OnDestroy {
	public billingState: BillingState;

	 private subscriptionComponent: SubscriptionComponent;
	 private usageComponent: UsageComponent;
	 private creditCardComponent: CreditCardComponent;
	 private upgradeOrDowngradeComponent: UpgradeOrDowngradeComponent;
	 private oneTimeCreditsComponent: OneTimeCreditsComponent;
	 private invoiceComponent: InvoiceComponent;

	private clientActionsSubscription: Subscription;
	private unsubscribe$ = new Subject();

	constructor(
		private titleService: Title,
		private billingStateService: BillingStateService,
		private authService: AuthService,
		private clientService: SharedClientService
	) {
		this.setAppTitle();
	}

	public ngOnInit(): void {
		this.subscribeToBillingState();
		this.getClient();
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		if (this.clientActionsSubscription) {
			this.clientActionsSubscription.unsubscribe();
		}
	}

	public setAppTitle(): void  {
		this.titleService.setTitle('hackajob.co - Billing');
	}

	private subscribeToBillingState(): void {
		this.billingStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.billingState = state;
			}
		);
	}

	private getClient(): void {
		this.clientService.get(this.authService.userId).subscribe(
			(client) => {
				this.billingStateService.setIsMasterAccount(client.is_master_account);
			}
		);
	}
static ctorParameters() { return [ { type: Title }, { type: BillingStateService }, { type: AuthService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/billing.component.ts